function agentDealerMapping() {

    let agentDealerMapService = [
        {
            name: "Cash Lifting",
            icon: "Cash Lifting",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "agentDealerMapping",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/agent-Dealer-Map",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD",
            },
        ];

        return dashboardArr;
    };

    const AgentDealerMap = () => {
        const profileArr = [
            {
                path: "/index/Agent-DealerMap",
                name: "Agent Dealer Mapping",
                icon: "fee-master",
                logoName: "customer master",
                flag: "AGENT DEALER MAPPING",
            },
        ];
        return profileArr;
    };

    let a = dashboard();
    let b = AgentDealerMap();

    agentDealerMapService[0].items = [...a, ...b];

    return agentDealerMapService;
}

export default agentDealerMapping;